import React, { memo } from "react";

import { Handle } from "react-flow-renderer";

export default memo(({ id, data }) => {
  if (!data) return;
  return (
    <>
      <Handle type="target" position="top" />
      <div onDoubleClick={() => data.onDoubleClick(id, data, "email")}>
        {data?.subject ? data.subject : "Double click to edit..."}
      </div>
      <Handle type="source" position="bottom" />
    </>
  );
});
